module.exports = __webpack_public_path__ + "img/home-logo-normal.2b26f5f4.png";